import React, { Component } from 'react';
import {connect } from 'react-redux';
import {getMainData,addUser,restUser,getmyData2} from "../../Redux/ducks/mainReducer";
import {Alert,Label,Row,Col,FormGroup,Input, Button,SpinnerModal,Modal,
    ModalBody, ModalFooter,ModalHeader,Spinner} from 'reactstrap'
import MultiSelect from "@kenshooui/react-multi-select";
import { getName } from '../../GeneralFunctions/general';
import ReactJsAlert from "reactjs-alert"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Redirect } from "react-router-dom";
export class AddApplication extends Component {
    state={
        isSaving:false,
        isLoading:true,
        mainData:null,
        msg:null,
        downloadPath:null,
        addCatMsg:null,
        btnDisabled:false,
        errorMsg:null,
        successMsg:null,
        noCat:null,
        subData:[],
        classData:[],
        streamData:[],
        gamesData:[],
        clubsData:[],
        modalDownload:false,
        previewURL:null,
        alertStatus :false, alertType :"error", alertTitle:null,
        modal:false,erroModalMsg:null,isUpdating:null,

        step1:true,step2:false,step3:false,serialNo:"",surname:"",firstname:"",othername:"",gender:"",dob:"",religion:"",level:"",sclass:"",stream:"",nationality:"",aggr:"",school:"",grade:""
        ,communion:"",mugigi:"",confirmation:"",guardian:"",f_name:"",f_dob:"",f_nationality:"",f_dis:"",f_county:"",f_scounty:"",f_village:"",f_occup:"",f_job:"",f_work:"",
        f_postal:"",f_phone:"",f_email:"",m_name:"",m_dob:"",m_nationality:"",m_dis:"",m_county:"",m_scounty:"",m_village:"",m_occup:"",m_job:"",m_work:"",m_postal:"",m_phone:"",
        m_email:"",sibNo:"",birthOrder:"",sib1:"",work1:"",sib2:"",work2:"",sib3:"",work3:"",sib4:"",work4:"",sib5:"",work5:"",fees:"",sponsor:"",bursary:"",handicaps:"",disease:"",
        allergy:"",food:"",problems:"",jobs:"",leader:"",house:"",photo:"",nin:"",orphan:"",photo2:"",m_nin:"",f_nin:"",lin:"",

        selectedSubjects: [],selectedPapers: [],clubs:[],games:[],bestSubjects: [],momoPhone:"",applicationFee:"",
        goNext:1,applicationData:null,

        applicationStatus:0,status:"",photo2Name:"",photoName:"",applicationID:0,goDashboard:false

    }


    async componentDidMount() {
        await this.props.getMainData("STAFFREGDATA");
  
    }
        
    componentDidUpdate(prevProps){
        const{mainData,msg,mainDataStatus,addUserStatus,getData2Status,getData2} = this.props;
        const{goNext} = this.state;
        if(mainDataStatus !== prevProps.mainDataStatus){
            if(mainDataStatus===true){
                this.setState({isSaving:false,mainData:mainData,applicationFee:mainData.applicationFee})
                const gamesData =  mainData.gamesData
                if(gamesData.length>0){
                    let gamesDataList = [];
                    gamesData.map((values,i) =>{
                        gamesDataList.push({id: values.id, label: values.name})
                    })
                    this.setState({gamesData:gamesDataList})
                }

                const clubsData =  mainData.clubsData
                if(clubsData.length>0){
                    let clubsDataList = [];
                    clubsData.map((values,i) =>{
                        clubsDataList.push({id: values.id, label: values.name})
                    })
                    this.setState({clubsData:clubsDataList})
                }
            }
        } 

       
        if(addUserStatus !== prevProps.addUserStatus){
            if(addUserStatus===true){
                /**work on msg */
                this.setState({applicationID:msg,isSaving:false,btnDisabled:false,modal:false,})
                if(parseInt(goNext)===1){
                    this.setState({ step1:true,step2:false,step3:false})
                }
                if(parseInt(goNext)===2){
                    this.setState({ step1:false,step2:true,step3:false})
                }
                if(parseInt(goNext)===3){
                    this.setState({ step1:false,step2:false,step3:true})
                }
                if(parseInt(goNext)===4){
                    alert(msg)
                    this.setState({alertStatus :true, alertType :"success", alertTitle:msg,isSaving:false,btnDisabled:false,modal:false,
                    step1:false,step2:false,step3:false,applicationStatus:1,goDashboard:true})
                }

                this.props.getMainData("STAFFREGDATA")
            }else if(addUserStatus===false){
                this.setState({alertStatus :true, alertType :"error", alertTitle:msg,isSaving:false,btnDisabled:false,modal:false})
            }
        } 
    }

    /**for multiple select */
    handleSelectChange = (selectedSubjects) =>{
        console.log(selectedSubjects)
        this.setState({ selectedSubjects });
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
        if (String([e.target.name]) ==="level"){
            if(this.state.mainData !==null){
                //for setting subjects
                const mySubData =  this.state.mainData.subjectData
                //loop through the array
                if(mySubData.length>0){
                    let subDataList = [];
                    mySubData.map((values,i) =>{
                        if(parseInt(e.target.value) ===3){
                            subDataList.push({id: values.id, label: values.name})
                        }else if(parseInt(e.target.value) ===parseInt(values.level)){
                            subDataList.push(
                                {/*<option key={i} value={values.id}>{values.name}</option>*/
                                id: values.id, label: values.name}
                            )
                        }
                    })
                    this.setState({subData:subDataList})
                }

                //for setting class
                const myClassData =  this.state.mainData.classData
                //loop through the array
                if(myClassData.length>0){
                    let classDataList = [];
                    myClassData.map((values,i) =>{
                        if(parseInt(e.target.value) ===parseInt(values.level_id)){
                            if(parseInt(values.id) ===4 || parseInt(values.id) ===6){
                            }else{
                                classDataList.push(
                                    <option key={i} value={values.id}>{values.name}</option>
                                )
                            }
                        }
                    })
                    this.setState({classData:classDataList})
                }
            }
        }else if (String([e.target.name]) ==="sclass"){
            
                //for setting stream
                const myStreamData =  this.state.mainData.streamData
                const myClassData =  this.state.mainData.classData
                //loop through the array
                if(myStreamData.length>0){
                    let streamDataList = [];

                    myClassData.map((values,i) =>{
                        if(parseInt(e.target.value) ===parseInt(values.id)){
                            const classStream = values.streams
                            //turn into a list 
                            var classStreamList = classStream.split(",");
                            //console.log("streams"+classStreamList)
                            myStreamData.map((values,i) =>{
                                if(classStreamList.includes(values.id.toString()) ===true){
                                    streamDataList.push(
                                        <option key={i} value={values.id}>{values.name}</option>
                                    )
                                }
                            })
                        }
                    })
               
                    this.setState({streamData:streamDataList})
                }

    
        }else{
            this.setState({[e.target.name]:e.target.value})
        }
    }

    closeModal = ()=>{
        this.setState({modal:false,selectedPapers:[],erroModalMsg:null,isUpdating:null,btnDisabled:false})
    }
    closeModalDownload = ()=>{
        this.setState({modalDownload:false})
    }
    alevelReg =()=>{
        this.setState({selectedPapers:[],modal:true,erroModalMsg:null,isUpdating:null,btnDisabled:false})
    }

    /**dynamic feild ui */
    createUI=()=>{
        return this.state.selectedSubjects.map((values, i) => (
            <div key={i}>
                <Row>
                    <Col xs="3" ></Col>
                    <Col xs="6" >
                        <Label for="teaching_sub">Select {getName(this.state.mainData.subjectData,values.id)} Paper(s)*</Label>
                        <MultiSelect 
                            responsiveHeight={'190px'}
                            items={this.getSubjectPapers(values.id)}
                            selectedItems={this.state.selectedPapers}
                            onChange={this.handleSelectChangePapers}
                            showSelectedItems={false}
                        />
                    </Col>
                    <Col xs="3" ></Col>
                </Row>
            </div>          
        ))
    }

    getSubjectPapers=(subjectID)=>{
     
        const paperDataList = [];
        if(this.state.mainData !==null){
            const paperData =  this.state.mainData.paperData
            //loop through the array
            paperData.map((values,i) =>{
                //console.log("name "+values.name)
                if(parseInt(values.subjectID)===parseInt(subjectID)){
                    paperDataList.push({id: values.id, label: values.name})
                  
                }
            });
        }
        //console.log(paperDataList)
        return paperDataList
    }

    /**for multiple select */
    handleSelectChangePapers = (selectedPapers) =>{
        //console.log(selectedPapers)
        this.setState({selectedPapers});
    }

    backOne = (action)=>{
        if(parseInt(action) ===1){
            this.setState({step1:true,step2:false,step3:false})
        }
        if(parseInt(action) ===2){
            this.setState({step1:false,step2:true,step3:false})
        }
        
    }
   
    handleSelectChange_clubs = (clubs) =>{
        this.setState({ clubs });
    }

    handleSelectChange_games = (games) =>{
        this.setState({ games });
    }

    handleSelectChange_bestSubjects = (bestSubjects) =>{
        this.setState({ bestSubjects });
    }

    haddlePhoto = (e) => {
        const selectedImage = e.target.files[0]
        const previewURL = URL.createObjectURL(selectedImage);
        this.setState({photo:selectedImage,previewURL:previewURL,photoName:""})
    }
    haddlePhoto2 = (e) => {
        this.setState({photo2:e.target.files[0],photo2Name:""})
    }

    next = (action)=>{
        const {serialNo,surname,firstname,gender,dob,photo2Name,photoName,
            religion,selectedSubjects,level,sclass,stream,nationality,school,grade,aggr,photo,photo2,momoPhone,house,m_nin,f_nin} = this.state;
        if(parseInt(action) ===2){
            if(serialNo===""||surname===""||firstname===""||dob===""||nationality===""||level===""||gender===""||
            religion===""||sclass===""||school===""||grade===""||aggr===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Please enter all fields marked with a *"})
            }else if(selectedSubjects.length<1){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Select at least one subject"})
            }else if(/\s/.test(serialNo)){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Index number must not contain spaces"})
            }else{
                this.setState({goNext:2})
                this.addUser(1)
            }
        }

        if(parseInt(action) ===3){
            if(f_nin===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Please enter father/Guardian's NIN"})
            }else if(m_nin===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Please enter mother/Guardian's NIN"})
            }else if(house===""||house===null){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Please select residency type"})
            }else if(photo==="" && (photoName===""||photoName===null)){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Upload student photo"})
            }else if(photo2==="" && (photo2Name===""||photo2Name===null)){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Upload passlip photo"})
            }else{
                this.setState({goNext:3})
                this.addUser(2)
            }
        }

        if(parseInt(action) ===4){
            this.setState({goNext:4})
            this.addUser(3)
            
        }
        
    }

    /**add new user*/
    addUser =(actionType)=>{
        this.props.restUser()
        const {serialNo,surname,firstname,gender,dob,
            religion,selectedSubjects,level,sclass,stream,nationality,school,grade,aggr,
            othername,communion,mugigi,confirmation,guardian,
            f_name,f_dob,f_nationality,f_dis,f_county,f_scounty,f_village,f_occup,f_job,f_work,f_postal,f_phone,f_email,
            m_name,m_dob,m_nationality,m_dis,m_county,m_scounty,m_village,m_occup,m_job,m_work,m_postal,m_phone,m_email,
            sibNo,birthOrder,sib1,work1,sib2,work2,sib3,work3,sib4,work4,sib5,work5,fees,sponsor,bursary,handicaps,disease,
            allergy,food,problems,jobs,leader,house,photo,clubs,games,bestSubjects,nin,orphan,photo2,momoPhone,applicationFee,
            f_nin,m_nin,lin,photoName,photo2Name,applicationID
        } = this.state;
     
      
         
            /**arranging  subjects */
            const subjectList = [];
            selectedSubjects.map((values) =>{
                subjectList.push(values.id)
            })

            /**arranging  games */
            const gamesList = [];
            games.map((values) =>{
                gamesList.push(values.id)
            })

            /**arranging  clubs */
            const clubsList = [];
            clubs.map((values) =>{
                clubsList.push(values.id)
            })

            /**arranging  bestSubjects */
            const bestSubjectsList = [];
            bestSubjects.map((values) =>{
                bestSubjectsList.push(values.id)
            })

            const data = new FormData();
            data.append("studentNo",serialNo);
            data.append("surname",surname);
            data.append("firstname",firstname);
            data.append("othername",othername);
            data.append("gender",gender);
            data.append("dob",dob);
            data.append("religion",religion);
            data.append("subjectList",subjectList);
            data.append("nationality",nationality);
            data.append("gamesList",gamesList);
            data.append("clubsList",clubsList);
            data.append("bestSubjectsList",bestSubjectsList);
            data.append("sclass",sclass);
            data.append("level",level);
            data.append("communion",communion);
            data.append("mugigi",mugigi);
            data.append("confirmation",confirmation);
            data.append("orphan",orphan);
            data.append("guardian_info",guardian);
            data.append("f_name",f_name);
            data.append("f_dob",f_dob);
            data.append("f_nationality",f_nationality);
            data.append("f_dis",f_dis);
            data.append("f_county",f_county);
            data.append("f_scounty",f_scounty);
            data.append("f_village",f_village);
            data.append("f_occup",f_occup);
            data.append("f_job",f_job);
            data.append("f_work",f_work);
            data.append("f_postal",f_postal);
            data.append("f_phone",f_phone);
            data.append("f_email",f_email);
            data.append("m_name",m_name);
            data.append("m_dob",m_dob);
            data.append("m_nationality",m_nationality);
            data.append("m_dis",m_dis);
            data.append("m_county",m_county);
            data.append("m_scounty",m_scounty);
            data.append("m_village",m_village);
            data.append("m_occup",m_occup);
            data.append("m_job",m_job);
            data.append("m_work",m_work);
            data.append("m_postal",m_postal);
            data.append("m_phone",m_phone);
            data.append("m_email",m_email);
            data.append("sibNo",sibNo);
            data.append("birthOrder",birthOrder);
            data.append("sib1",sib1);
            data.append("work1",work1);
            data.append("sib2",sib2);
            data.append("work2",work2);
            data.append("sib3",sib3);
            data.append("work3",work3);
            data.append("sib4",sib4);
            data.append("work4",work4);
            data.append("sib5",sib5);
            data.append("work5",work5);
            data.append("fees",fees);
            data.append("sponsor",sponsor);
            data.append("bursary",bursary);
            data.append("handicaps",handicaps);
            data.append("disease",disease);
            data.append("allergy",allergy);
            data.append("food",food);
            data.append("problems",problems);
            data.append("jobs",jobs);
            data.append("leader",leader);
            data.append("house",house);
            data.append("photo",photo);
            data.append("photo2",photo2);
            data.append("school",school);
            data.append("grade",grade);
            data.append("aggr",aggr);
            data.append("nin",nin);
            data.append("lin",lin);
            data.append("m_nin",m_nin);
            data.append("f_nin",f_nin);
            data.append("applicationFee",applicationFee);
            data.append("momoPhone",momoPhone);
            const userData = JSON.parse(window.localStorage.getItem('userData'));
            const id = userData.id
            data.append("id",id);
            data.append("actionType",actionType)
            data.append("applicationID",applicationID)
  
      
    
            this.setState({isSaving:true,btnDisabled:true})
                /**upload new user*/
            this.props.addUser(data,"STUDENT")
           
      
    }
    /**add a */
    addUserAlevel = ()=>{
        this.props.restUser()
        const {serialNo,surname,firstname,gender,dob,
            religion,selectedSubjects,level,sclass,stream,nationality,school,grade,aggr,
            othername,communion,mugigi,confirmation,guardian,
            f_name,f_dob,f_nationality,f_dis,f_county,f_scounty,f_village,f_occup,f_job,f_work,f_postal,f_phone,f_email,
            m_name,m_dob,m_nationality,m_dis,m_county,m_scounty,m_village,m_occup,m_job,m_work,m_postal,m_phone,m_email,
            sibNo,birthOrder,sib1,work1,sib2,work2,sib3,work3,sib4,work4,sib5,work5,fees,sponsor,bursary,handicaps,disease,
            allergy,food,problems,jobs,leader,house,photo,clubs,games,bestSubjects,nin,orphan,
            selectedPapers,applicationID} = this.state;
        
        if(selectedPapers.length<1){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Select papers per subject as to be taken by the student"})

        }else{
            this.setState({erroMsg:null,erroModalMsg:null,isUpdating:true,btnDisabled:true,successMsg:null})
         
            /**arranging  subject */
            const subjectList = [];
            selectedSubjects.map((values) =>{
                subjectList.push(values.id)
            })

            /**arranging  papers */
            const papersList = [];
            selectedPapers.map((values) =>{
                papersList.push(values.id)
            })

             /**arranging  games */
             const gamesList = [];
             games.map((values) =>{
                 gamesList.push(values.id)
             })
 
             /**arranging  clubs */
             const clubsList = [];
             clubs.map((values) =>{
                 clubsList.push(values.id)
             })
 
             /**arranging  bestSubjects */
             const bestSubjectsList = [];
             bestSubjects.map((values) =>{
                 bestSubjectsList.push(values.id)
             })

            const data = new FormData();
            data.append("studentNo",serialNo);
            data.append("surname",surname);
            data.append("firstname",firstname);
            data.append("othername",othername);
            data.append("gender",gender);
            data.append("dob",dob);
            data.append("religion",religion);
            data.append("subjectList",subjectList);
            data.append("nationality",nationality);
            data.append("gamesList",gamesList);
            data.append("clubsList",clubsList);
            data.append("bestSubjectsList",bestSubjectsList);
            data.append("sclass",sclass);
            data.append("stream",stream);
            data.append("level",level);
            data.append("communion",communion);
            data.append("mugigi",mugigi);
            data.append("confirmation",confirmation);
            data.append("orphan",orphan);
            data.append("guardian_info",guardian);
            data.append("f_name",f_name);
            data.append("f_dob",f_dob);
            data.append("f_nationality",f_nationality);
            data.append("f_dis",f_dis);
            data.append("f_county",f_county);
            data.append("f_scounty",f_scounty);
            data.append("f_village",f_village);
            data.append("f_occup",f_occup);
            data.append("f_job",f_job);
            data.append("f_work",f_work);
            data.append("f_postal",f_postal);
            data.append("f_phone",f_phone);
            data.append("f_email",f_email);
            data.append("m_name",m_name);
            data.append("m_dob",m_dob);
            data.append("m_nationality",m_nationality);
            data.append("m_dis",m_dis);
            data.append("m_county",m_county);
            data.append("m_scounty",m_scounty);
            data.append("m_village",m_village);
            data.append("m_occup",m_occup);
            data.append("m_job",m_job);
            data.append("m_work",m_work);
            data.append("m_postal",m_postal);
            data.append("m_phone",m_phone);
            data.append("m_email",m_email);
            data.append("sibNo",sibNo);
            data.append("birthOrder",birthOrder);
            data.append("sib1",sib1);
            data.append("work1",work1);
            data.append("sib2",sib2);
            data.append("work2",work2);
            data.append("sib3",sib3);
            data.append("work3",work3);
            data.append("sib4",sib4);
            data.append("work4",work4);
            data.append("sib5",sib5);
            data.append("work5",work5);
            data.append("fees",fees);
            data.append("sponsor",sponsor);
            data.append("bursary",bursary);
            data.append("handicaps",handicaps);
            data.append("disease",disease);
            data.append("allergy",allergy);
            data.append("food",food);
            data.append("problems",problems);
            data.append("jobs",jobs);
            data.append("leader",leader);
            data.append("house",house);
            data.append("photo",photo);
            data.append("school",school);
            data.append("grade",grade);
            data.append("aggr",aggr);
            data.append("nin",nin);
            data.append("papersList",papersList);

            this.props.addUser(data,"STUDENT")
        }

    }


    render() {
        if(this.state.goDashboard){
            return <Redirect push to="/dashboard" />  
        }
        const {mainData,selectedSubjects,bestSubjects,clubs,games,applicationData} = this.state
        /**displaying  categories*/
        const catDataList = [];
        if(this.state.mainData !==null){
            const myCatData =  this.state.mainData.catData
            //loop through the array
            if(myCatData.length>0){
                catDataList.push(<option key="" value="">SELECT ACCOUNT TYPE</option>)
                myCatData.map((values,i) =>{
                    catDataList.push(
                        <option key={i} value={values.catName}>{values.catName}</option>
                    )
                
                });
            }else{
                catDataList.push(  
                    <option value="">No category found</option>   
                )
            }
        }

        /**displaying  levels*/
        const levelDataList = [];
        if(this.state.mainData !==null){
            const mylevelData =  this.state.mainData.levelData
            //loop through the array
            if(mylevelData.length>0){
                levelDataList.push(<option key="" value="">SELECT LEVEL</option>)
                mylevelData.map((values,i) =>{
                    if( parseInt(values.id)!==3){
                        levelDataList.push(
                            <option key={i} value={values.id}>{values.name}</option>
                        )
                    }
                });
            }else{
                levelDataList.push(  
                    <option value="">No level found</option>   
                )
            }
        }

        /**displaying  levels*/
        const religionDataList = [];
        if(this.state.mainData !==null){
            const myreligionData =  this.state.mainData.religionData
            //loop through the array
            if(myreligionData.length>0){
                religionDataList.push(<option key="" value="">SELECT RELIGION</option>)
                myreligionData.map((values,i) =>{
                    religionDataList.push(
                        <option key={i} value={values.id}>{values.name}</option>
                    )
                });
            }else{
                religionDataList.push(  
                    <option value="">No religion found</option>   
                )
            }
        }

        const housesDataList = [];
        if(this.state.mainData !==null){
            const myreligionData =  this.state.mainData.residencyData
            //loop through the array
            if(myreligionData.length>0){
                housesDataList.push(<option key="" value="">SELECT RESIDENCY</option>)
                myreligionData.map((values,i) =>{
                    housesDataList.push(
                        <option key={i} value={values.id}>{values.name}</option>
                    )
                });
            }else{
                housesDataList.push(  
                    <option value="">No data found</option>   
                )
            }
        }

        const subjectList = [];
        if(selectedSubjects !==null){
            selectedSubjects.map((values) =>{
                subjectList.push(getName(mainData.subjectData,values.id))
            })
        }
        const selectedSubjects2 = subjectList.join(",");
       
        /**arranging  games */
        const gamesList = [];
        if(games !==null){
            games.map((values) =>{
                gamesList.push(getName(mainData.gamesData,values.id))
            })
        }
        const seletedGames = gamesList.join(",");
        /**arranging  clubs */
        const clubsList = [];
        if(clubs !==null){
            clubs.map((values) =>{
                clubsList.push(getName(mainData.clubsData,values.id))
            })
        }
        const seletedClubs = clubsList.join(",");

        /**arranging  bestSubjects */
        const bestSubjectsList = [];
        if(bestSubjects !==null){
            bestSubjects.map((values) =>{
                bestSubjectsList.push(getName(mainData.subjectData,values.id))
            })
        }
        const seletedBestSubjects = bestSubjectsList.join(",");


        const circularImageStyle = {
            borderRadius: '50%',
            overflow: 'hidden',
            width: '150px', // Set a fixed width for the circular image
            height: '150px', // Set a fixed height for the circular image
          }
        
        return (
            <div>
                <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                <div className="">
                    <div className="block-header">
                    <h4>STUDENT APPLICATION</h4>
                    </div>
                
                    <div className="mainWrraper">

                        {parseInt(this.state.applicationStatus)===0?
                        <>
                        {this.state.step1?
                        <Row>
                            <Col md="6" xs="12">
                                {this.state.addCatMsg?<Alert color="danger">{this.state.addCatMsg}</Alert>:null}
                    
                                <FormGroup>
                                    <Label for="username">Surname*</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.surname} name="surname" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="username">Firstname*</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.firstname} name="firstname"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="username">Othername</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.othername} name="othername" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="gender">Gender*</Label>
                                    <Input type="select" onChange={this.setValue} name="gender">
                                        <option value="">SELECT GENDER</option> 
                                        <option value="Male">Male</option> 
                                        <option value="Female">Female</option> 
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="dob">Date Of Birth*</Label>
                                    <Input type="date" onChange={this.setValue} value={this.state.dob} name="dob"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="religion">Religion*</Label>
                                    <Input type="select" onChange={this.setValue} name="religion">
                                        {religionDataList}
                                    </Input>
                                </FormGroup>


                                <FormGroup>
                                    <Label for="level">Level To Join*</Label>
                                    <Input type="select" onChange={this.setValue} name="level">
                                        {levelDataList}
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone2">School where  {parseInt(this.state.level) ===2?"UCE":"PLE"} was done*</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.school} name="school" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="name">{parseInt(this.state.level) ===2?"UCE":"PLE"} Index Number*</Label>
                                    <Input type="text"  name="serialNo" onChange={this.setValue} value={this.state.serialNo}/>
                                </FormGroup>
                                <Row>
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                        <Label for="name">{parseInt(this.state.level) ===2?"UCE":"PLE"} Aggregates*</Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.aggr} name="aggr" />
                                        </FormGroup>
                                    </Col> 
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                        <Label for="name">{parseInt(this.state.level) ===2?"UCE":"PLE"} Grade*</Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.grade} name="grade" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                               

                            </Col>
                            
                            <Col md="6" xs="12" >
                                <FormGroup>
                                    <Label for="phone">LIN</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.lin} name="lin"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone">Nationality*</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.nationality} name="nationality"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone2">Holy Communion?</Label>
                                    <Input type="select" onChange={this.setValue} name="communion">
                                        <option value="">SELECT</option> 
                                        <option value="YES">YES</option> 
                                        <option value="NO">NO</option> 
                                    </Input>
                                </FormGroup>
                                <Row>
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                            <Label for="phone2">Confirmation?</Label>
                                            <Input type="select" onChange={this.setValue} name="confirmation">
                                                <option value="">SELECT</option> 
                                                <option value="YES">YES</option> 
                                                <option value="NO">NO</option> 
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                            <Label for="phone2">Final Commitment (Mugigi)? </Label>
                                            <Input type="select" onChange={this.setValue} name="mugigi">
                                                <option value="">SELECT</option> 
                                                <option value="YES">YES</option> 
                                                <option value="NO">NO</option> 
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <FormGroup>
                                    <Label for="phone2">Are you Orphan?</Label>
                                    <Input type="select" onChange={this.setValue} name="orphan">
                                        <option value="">SELECT</option> 
                                        <option value="YES">YES</option> 
                                        <option value="NO">NO</option> 
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone2">If Yes, Guardian details</Label>
                                    <Input type="textarea" onChange={this.setValue} name="guardian" rows="2"/>
                    
                                </FormGroup>
                               
                                <FormGroup>
                                    <Label for="class">Class*</Label>
                                    <Input type="select" onChange={this.setValue} name="sclass">
                                        <option value="">SELECT CLASS</option> 
                                        {this.state.classData}
                                    </Input>
                                </FormGroup>
                            
                                <FormGroup>
                                    <Label for="teaching_sub">Subjects*</Label>
                                    <MultiSelect 
                                        responsiveHeight={'190px'}
                                        items={this.state.subData}
                                        selectedItems={this.state.selectedSubjects}
                                        onChange={this.handleSelectChange}
                                    />
                                </FormGroup>
                                

                            </Col>
                            <Col xs="12" >
                            {this.state.isSaving?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Saving...'}</div>:null}
                                <Button onClick={()=>this.next(2)} className="btn btn-block btn-lg btn-danger">Save & Continue</Button>
                            </Col>
                        </Row>
                        :null}

                        {/**
                         * ********************************************
                         * STEP TWO
                         * ********************************************
                         */}
                        {this.state.step2?
                        <Row>
                            <Col md="6" xs="12">
                                <Label className="mySection">Father/ Guardian Section</Label>
                                <FormGroup>
                                    <Label for="name">Father/ Guardian Name </Label>
                                    <Input type="text"  name="f_name" onChange={this.setValue} value={this.state.f_name}/>
                                </FormGroup>
                            
                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Date Of Birth</Label>
                                            <Input type="date" onChange={this.setValue} value={this.state.f_dob} name="f_dob"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Nationality</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_nationality} name="f_nationality"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">District</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_dis} name="f_dis"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">County</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_county} name="f_county"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Sub-county</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_scounty} name="f_scounty"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Village/Town</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_village} name="f_village"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Occupation</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_occup} name="f_occup"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Job Position</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_job} name="f_job"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Place of Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_work} name="f_work"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Postal address</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.f_postal} name="f_postal"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone2">Phone No</Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.f_phone} name="f_phone" />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Email</Label>
                                            <Input type="email" onChange={this.setValue} value={this.state.f_email} name="f_email"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Label for="name">Father/ Guardian NIN* </Label>
                                    <Input type="text"  name="f_nin" onChange={this.setValue} value={this.state.f_nin}/>
                                </FormGroup>


                                <Label className="mySection">Mother Section</Label>
                                <FormGroup>
                                    <Label for="name">Mother/ Guardian Name </Label>
                                    <Input type="text"  name="m_name" onChange={this.setValue} value={this.state.m_name}/>
                                </FormGroup>
                            
                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Date Of Birth</Label>
                                            <Input type="date" onChange={this.setValue} value={this.state.m_dob} name="m_dob"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Nationality</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_nationality} name="m_nationality"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">District</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_dis} name="m_dis"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">County</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_county} name="m_county"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Sub-county</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_scounty} name="m_scounty"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Village/Town</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_village} name="m_village"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Occupation</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_occup} name="m_occup"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Job Position</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_job} name="m_job"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Place of Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_work} name="m_work"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Postal address</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_postal} name="m_postal"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone2">Phone No</Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.m_phone} name="m_phone" />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Email</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.m_email} name="m_email"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Label for="name">Mother/ Guardian NIN* </Label>
                                    <Input type="text"  name="m_nin" onChange={this.setValue} value={this.state.m_nin}/>
                                </FormGroup>

                                <Label className="mySection">Siblings Section</Label>
                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings? </Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.sibNo} name="sibNo"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Birth order?</Label>
                                            <Input type="number" onChange={this.setValue} value={this.state.birthOrder} name="birthOrder"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings 1</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.sib1} name="sib1"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">School/Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.work1} name="work1"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings 2</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.sib2} name="sib2"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">School/Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.work2} name="work2"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings 3</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.sib3} name="sib3"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">School/Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.work3} name="work3"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings 4</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.sib4} name="sib4"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">School/Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.work4} name="work4"/>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Siblings 5</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.sib5} name="sib5"/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">School/Work</Label>
                                            <Input type="text" onChange={this.setValue} value={this.state.work5} name="work5"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                               

                            </Col>
                            <Col md="6" xs="12" >
                                <Label className="mySection">Other Information</Label>
                                <FormGroup>
                                    <Label for="phone">Clubs To Join</Label>
                                    <MultiSelect 
                                        responsiveHeight={'200px'}
                                        items={this.state.clubsData}
                                        selectedItems={this.state.clubs}
                                        onChange={this.handleSelectChange_clubs}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Games To Play</Label>
                                    <MultiSelect 
                                        responsiveHeight={'200px'}
                                        items={this.state.gamesData}
                                        selectedItems={this.state.games}
                                        onChange={this.handleSelectChange_games}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Best Subjects</Label>
                                    <MultiSelect 
                                        responsiveHeight={'200px'}
                                        items={this.state.subData}
                                        selectedItems={this.state.bestSubjects}
                                        onChange={this.handleSelectChange_bestSubjects}
                                    />
                                </FormGroup>

                                <Row>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="dob">Who pays fees?</Label>
                                            <Input type="select" onChange={this.setValue} name="fees">
                                                <option value="">SELECT</option> 
                                                <option value="DAD">DAD</option> 
                                                <option value="MOTHER">MOTHER</option> 
                                                <option value="GUARDIAN">GUARDIAN</option>
                                                <option value="DAD AND MOTHER">DAD AND MOTHER</option>
                                            </Input>  
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <FormGroup>
                                            <Label for="phone">Bursary?</Label>
                                            <Input type="select" onChange={this.setValue} name="bursary">
                                                <option value="">SELECT</option> 
                                                <option value="YES">YES</option> 
                                                <option value="NO">NO</option> 
                                            </Input>                                        
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Label for="phone">if on Bursary,sponsor details</Label>
                                    <Input type="textarea" rows="2" onChange={this.setValue} value={this.state.sponsor} name="sponsor"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone">Physical handicaps?</Label>
                                    <Input type="textarea" rows="2" onChange={this.setValue} value={this.state.handicaps} name="handicaps"/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone">Chronic disease?</Label>
                                    <Input type="textarea" rows="2" onChange={this.setValue} value={this.state.disease} name="disease"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Any allergies?</Label>
                                    <Input type="textarea" rows="2" onChange={this.setValue} value={this.state.allergy} name="allergy"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Foods you do not eat?</Label>
                                    <Input type="textarea" rows="2" onChange={this.setValue} value={this.state.food} name="food"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Personal problems?</Label>
                                    <Input type="textarea" rows="1" onChange={this.setValue} value={this.state.problems} name="problems"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Jobs to do / become ?</Label>
                                    <Input type="textarea" rows="1" onChange={this.setValue} value={this.state.jobs} name="jobs"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Student Leader?</Label>
                                    <Input type="select" onChange={this.setValue} name="leader">
                                        <option value="">SELECT</option> 
                                        <option value="YES">YES</option> 
                                        <option value="NO">NO</option> 
                                    </Input>                                        
                                </FormGroup>
                                <FormGroup>
                                    <Label for="phone">NIN</Label>
                                    <Input type="text" onChange={this.setValue} value={this.state.nin} name="nin"/>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Student Residency Type*</Label>
                                    <Input type="select" onChange={this.setValue} name="house">
                                        {housesDataList}
                                    </Input>                                        
                                </FormGroup>
                      

                                <Row>
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                            <Label for="phone2">Student Photo*</Label>
                                            <Input type="file" onChange={this.haddlePhoto} accept="image/png, image/jpeg"/>

                                        </FormGroup>
                                    </Col>
                                    <Col md="6" xs="12" >
                                        <FormGroup>
                                        <Label for="phone">{parseInt(this.state.level) ===2?"UCE ":"PLE " }Pass Slip Photo*</Label>
                                        <Input type="file" onChange={this.haddlePhoto2} accept="image/png, image/jpeg"/>

                                        </FormGroup>
                                    </Col>
                                </Row>

                            </Col>
                            <Col xs="12" >
                                {this.state.isSaving?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Saving...'}</div>:null}
                                <Row>
                                <Col md="6" xs="6">
                                    <Button onClick={()=>this.backOne(1)}  className="btn btn-block btn-lg btn-secondary">Back</Button>

                                </Col>


                                <Col md="6" xs="6">
                            
                                    <Button onClick={()=>this.next(3)} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Next</Button>
                                </Col>
                                </Row>
                            </Col>
                        </Row>
                        :null}

                         {/**
                         * ********************************************
                         * STEP THREE
                         * ********************************************
                         */}
                        {this.state.step3?
                        <Row>
                            <Col md="6" xs="12">
                                <Row style={{display: 'flex',justifyContent: 'center'}}>

                                    <div style={circularImageStyle}>
                                        {this.state.photo !==""?
                                        <img
                                            src={this.state.previewURL}
                                            alt="Selected Image"
                                            style={{
                                            maxWidth: '200px',
                                            maxHeight: '150px',
                                            objectFit: 'cover',
                                            }}
                                        />:
                                        <img
                                            src={process.env.REACT_APP_IMG_URL+"/storage/students/"+this.state.photoName}
                                            alt="Selected Image"
                                            style={{
                                            maxWidth: '200px',
                                            maxHeight: '150px',
                                            objectFit: 'cover',
                                            }}
                                        />
                                        }
                                    </div>
                                </Row>
                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Surname :</span> <span className='labelOne'>{this.state.surname}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Firstname :</span> <span className='labelOne'>{this.state.firstname}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Othername :</span> <span className='labelOne'>{this.state.othername}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Gender :</span> <span className='labelOne'>{this.state.gender}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>DOB :</span> <span className='labelOne'>{this.state.dob}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Religion :</span> <span className='labelOne'>{getName(mainData.religionData,this.state.religion)}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Level To Join :</span> <span className='labelOne'>{getName(mainData.levelData,this.state.level)}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>{parseInt(this.state.level) ===2?"UCE":"PLE"} School :</span> <span className='labelOne'>{this.state.school}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>{parseInt(this.state.level) ===2?"UCE":"PLE"} Index Number :</span> <span className='labelOne'>{this.state.serialNo}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>{parseInt(this.state.level) ===2?"UCE":"PLE"} Aggregates :</span> <span className='labelOne'>{this.state.aggr}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>{parseInt(this.state.level) ===2?"UCE":"PLE"} Grade :</span> <span className='labelOne'>{this.state.grade}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>LIN :</span> <span className='labelOne'>{this.state.lin}</span></Label>
                                </Row>
                                
                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Nationality :</span> <span className='labelOne'>{this.state.nationality}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Holy Communion? :</span> <span className='labelOne'>{this.state.communion}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Confirmation? :</span> <span className='labelOne'>{this.state.confirmation}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Final Commitment? :</span> <span className='labelOne'>{this.state.mugigi}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Are you Orphan? :</span> <span className='labelOne'>{this.state.orphan}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Guardian details :</span> <span className='labelOne'>{this.state.guardian}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Class :</span> <span className='labelOne'>{getName(mainData.classData,this.state.sclass)}</span></Label>
                                </Row>

                             
                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Subjects</span></Label>
                                    <Input type="textarea" value={selectedSubjects2} disabled className="ttx"/>
                                                
                                </Row>
                                <br/>
                             
                                <Label className="mySection">Father Section</Label><br/>
                                <Label for="phone"><span className='labelOne1'>Father Name :</span> <span className='labelOne'>{this.state.f_name}</span></Label>
                                <br/>
                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Father BOB :</span> <span className='labelOne'>{this.state.f_dob}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Nationality :</span> <span className='labelOne'>{this.state.f_nationality}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>District :</span> <span className='labelOne'>{this.state.f_dis}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>County :</span> <span className='labelOne'>{this.state.f_county}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Sub-county :</span> <span className='labelOne'>{this.state.f_scounty}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Village/Town :</span> <span className='labelOne'>{this.state.f_village}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Occupation :</span> <span className='labelOne'>{this.state.f_occup}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Job :</span> <span className='labelOne'>{this.state.f_job}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Place of Work :</span> <span className='labelOne'>{this.state.f_work}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Postal address :</span> <span className='labelOne'>{this.state.f_postal}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Phone :</span> <span className='labelOne'>{this.state.f_phone}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Email :</span> <span className='labelOne'>{this.state.f_email}</span></Label>
                                    </Col>
                                </Row>
                            
                                <Label for="phone"><span className='labelOne1'>Father NIN :</span> <span className='labelOne'>{this.state.f_nin}</span></Label>
                                

                            </Col>

                            <Col md="6" xs="12">
                             
                                <br/>
                                <Label className="mySection">Mother Section</Label><br/>
                          

                                <Label for="phone"><span className='labelOne1'>Mother Name :</span> <span className='labelOne'>{this.state.m_name}</span></Label>
                              
                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Mother BOB :</span> <span className='labelOne'>{this.state.m_dob}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Nationality :</span> <span className='labelOne'>{this.state.m_nationality}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>District :</span> <span className='labelOne'>{this.state.m_dis}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>County :</span> <span className='labelOne'>{this.state.m_county}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Sub-county :</span> <span className='labelOne'>{this.state.m_scounty}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Village/Town :</span> <span className='labelOne'>{this.state.m_village}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Occupation :</span> <span className='labelOne'>{this.state.m_occup}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Job :</span> <span className='labelOne'>{this.state.m_job}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Place of Work :</span> <span className='labelOne'>{this.state.m_work}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Postal address :</span> <span className='labelOne'>{this.state.m_postal}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Phone :</span> <span className='labelOne'>{this.state.m_phone}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Email :</span> <span className='labelOne'>{this.state.m_email}</span></Label>
                                    </Col>
                                </Row>
                                <Label for="phone"><span className='labelOne1'>Mother NIN :</span> <span className='labelOne'>{this.state.m_nin}</span></Label>
                                <br/>
                                <Label className="mySection">Siblings Section</Label>
                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Siblings? :</span> <span className='labelOne'>{this.state.sibNo}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Birth order? :</span> <span className='labelOne'>{this.state.birthOrder}</span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Siblings 1 :</span> <span className='labelOne'>{this.state.sib1}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                       
                                        <Label for="phone"><span className='labelOne1'>School/Work :</span> <span className='labelOne'>{this.state.work1}</span></Label>

                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                  
                                        <Label for="phone"><span className='labelOne1'>Siblings 2 :</span> <span className='labelOne'>{this.state.sib2}</span></Label>

                                    </Col>
                                    <Col md="6" xs="12">
                                        
                                        <Label for="phone"><span className='labelOne1'>School/Work :</span> <span className='labelOne'>{this.state.work2}</span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6" xs="12">
                                     
                                        <Label for="phone"><span className='labelOne1'>Siblings 3 :</span> <span className='labelOne'>{this.state.sib3}</span></Label>

                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>School/Work :</span> <span className='labelOne'>{this.state.work3}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Siblings 4 :</span> <span className='labelOne'>{this.state.sib4}</span></Label>

                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>School/Work :</span> <span className='labelOne'>{this.state.work4}</span></Label>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>Siblings 5 :</span> <span className='labelOne'>{this.state.sib5}</span></Label>
                                    </Col>
                                    <Col md="6" xs="12">
                                        <Label for="phone"><span className='labelOne1'>School/Work :</span> <span className='labelOne'>{this.state.work5}</span></Label>
                                    </Col>
                                </Row>

                                <Label className="mySection">Other Information</Label>
                          
                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Clubs</span></Label>
                                    <Input type="textarea" value={seletedClubs} disabled className="ttx"/>
                                                
                                </Row>
                               

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Games</span></Label>
                                    <Input type="textarea" value={seletedGames} disabled className="ttx"/>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Best Subjects</span></Label>
                                    <Input type="textarea" value={seletedBestSubjects} disabled className="ttx"/>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Who pays fees? :</span> <span className='labelOne'>{this.state.fees}</span></Label>
                                </Row>

                                <Row>
                                <Label for="phone"><span className='labelOne1'>Bursary? :</span> <span className='labelOne'>{this.state.bursary}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Bursary details :</span> <span className='labelOne'>{this.state.sponsor}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Physical handicaps :</span> <span className='labelOne'>{this.state.handicaps}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Chronic disease :</span> <span className='labelOne'>{this.state.disease}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Any allergies :</span> <span className='labelOne'>{this.state.allergy}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Foods you do not eat :</span> <span className='labelOne'>{this.state.food}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Personal problems :</span> <span className='labelOne'>{this.state.problems}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Jobs to do / become :</span> <span className='labelOne'>{this.state.jobs}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Student Leader : </span> <span className='labelOne'>{this.state.leader}</span></Label>
                                </Row>

                                <Row>
                                    <Label for="phone"><span className='labelOne1'>NIN :</span> <span className='labelOne'>{this.state.nin}</span></Label>
                                </Row>
                                <Row>
                                    <Label for="phone"><span className='labelOne1'>Residency Type: </span> <span className='labelOne'>{getName(mainData.residencyData,this.state.house)}</span></Label>
                                </Row>
                            
                            </Col>
                            <Col xs="12" >
                                {this.state.isSaving?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Saving...'}</div>:null}
                                <Row>
                                    <Col md="6" xs="6">
                                        <Button onClick={()=>this.backOne(2)}  className="btn btn-block btn-lg btn-secondary">Back</Button>
                                    </Col>

                                    <Col md="6" xs="6">
                                        <Button onClick={()=>this.next(4)} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Confirm & Submit</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        :null}
                        </>:
                        <>

                            {this.state.isLoading===true?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}</div>:
                            <>
                                {parseInt(this.state.status)===1?
                                <Alert color="success">Application under review, we shall contact you soon</Alert>:null}

                                {parseInt(this.state.status)===2?
                                    <Alert color="danger">We regret to inform you, {applicationData.firstname}, that your application has not been accepted. The reason for this decision is: {applicationData.rejectionReason}. If you have any questions or need further clarification, please feel free to reach out. Thank you for your understanding.</Alert>:null}

                                {parseInt(this.state.status)===3?
                                <>
                                    <Alert color="success">Congratulations, {applicationData.firstname}! Your application has been accepted. Kindly download and print the documents listed below. On the reporting day, present the printed copies along with your original academic documents.</Alert>
                                    {parseInt(applicationData.levelID) ===1?
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/St Johns Requirements for Day Students.pdf"} download={"St Johns Requirements for Day Students.pdf"}>Download School Requirements</a>
                                    :
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/St Johns Requirements for Boarding Students.pdf"} download={"St Johns Requirements for Boarding Students.pdf"}>Download School Requirements</a>
                                    }
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/St johns_School rules.pdf"} download={"St johns_School rules.pdf"}>Download School Rules</a>
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/"+applicationData.admissionLetter} download={applicationData.admissionLetter}>Download Admission Letter</a>
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/"+applicationData.acceptanceForm} download={applicationData.acceptanceForm}>Download Acceptance Form</a>
                                    <a className="btn btn-block btn-lg btn-success" target="_blank" href={process.env.REACT_APP_IMG_URL+"/storage/admissions/"+applicationData.registrationForm} download={applicationData.registrationForm}>Download Registration Form</a>
                                    <></>
                                </>
                                :null}
                            </>}


                     
                        </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    mainDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    mainData : state.mainReducer.mainData,
    addUserStatus:state.mainReducer.addUserStatus,
    getData2Status:state.mainReducer.getData2Status,
    getData2:state.mainReducer.getData2,
});
export default connect(
    mapStateToProps, {getMainData,addUser,restUser,getmyData2}
)(AddApplication)
